export const reversedSqlWords = ['ADD',
  'EXTERNAL',
  'PROCEDURE',
  'ALL',
  'FETCH',
  'PUBLIC',
  'ALTER',
  'FILE',
  'RAISERROR',
  'AND',
  'FILLFACTOR',
  'READ',
  'ANY',
  'FOR',
  'READTEXT',
  'AS',
  'FOREIGN',
  'RECONFIGURE',
  'ASC',
  'FREETEXT',
  'REFERENCES',
  'AUTHORIZATION',
  'FREETEXTTABLE',
  'REPLICATION',
  'BACKUP',
  'FROM',
  'RESTORE',
  'BEGIN',
  'FULL',
  'RESTRICT',
  'BETWEEN',
  'FUNCTION',
  'RETURN',
  'BREAK',
  'GOTO',
  'REVERT',
  'BROWSE',
  'GRANT',
  'REVOKE',
  'BULK',
  'GROUP',
  'RIGHT',
  'BY',
  'HAVING',
  'ROLLBACK',
  'CASCADE',
  'HOLDLOCK',
  'ROWCOUNT',
  'CASE',
  'IDENTITY',
  'ROWGUIDCOL',
  'CHECK',
  'IDENTITY_INSERT',
  'RULE',
  'CHECKPOINT',
  'IDENTITYCOL',
  'SAVE',
  'CLOSE',
  'IF',
  'SCHEMA',
  'CLUSTERED',
  'IN',
  'SECURITYAUDIT',
  'COALESCE',
  'INDEX',
  'SELECT',
  'COLLATE',
  'INNER',
  'SEMANTICKEYPHRASETABLE',
  'COLUMN',
  'INSERT',
  'SEMANTICSIMILARITYDETAILSTABLE',
  'COMMIT',
  'INTERSECT',
  'SEMANTICSIMILARITYTABLE',
  'COMPUTE',
  'INTO',
  'SESSION_USER',
  'CONSTRAINT',
  'IS',
  'SET',
  'CONTAINS',
  'JOIN',
  'SETUSER',
  'CONTAINSTABLE',
  'KEY',
  'SHUTDOWN',
  'CONTINUE',
  'KILL',
  'SOME',
  'CONVERT',
  'LEFT',
  'STATISTICS',
  'CREATE',
  'LIKE',
  'SYSTEM_USER',
  'CROSS',
  'LINENO',
  'TABLE',
  'CURRENT',
  'LOAD',
  'TABLESAMPLE',
  'CURRENT_DATE',
  'MERGE',
  'TEXTSIZE',
  'CURRENT_TIME',
  'NATIONAL',
  'THEN',
  'CURRENT_TIMESTAMP',
  'NOCHECK',
  'TO',
  'CURRENT_USER',
  'NONCLUSTERED',
  'TOP',
  'CURSOR',
  'NOT',
  'TRAN',
  'DATABASE',
  'NULL',
  'TRANSACTION',
  'DBCC',
  'NULLIF',
  'TRIGGER',
  'DEALLOCATE',
  'OF',
  'TRUNCATE',
  'DECLARE',
  'OFF',
  'TRY_CONVERT',
  'DEFAULT',
  'OFFSETS',
  'TSEQUAL',
  'DELETE',
  'ON',
  'UNION',
  'DENY',
  'OPEN',
  'UNIQUE',
  'DESC',
  'OPENDATASOURCE',
  'UNPIVOT',
  'DISK',
  'OPENQUERY',
  'UPDATE',
  'DISTINCT',
  'OPENROWSET',
  'UPDATETEXT',
  'DISTRIBUTED',
  'OPENXML',
  'USE',
  'DOUBLE',
  'OPTION',
  'USER',
  'DROP',
  'OR',
  'VALUES',
  'DUMP',
  'ORDER',
  'VARYING',
  'ELSE',
  'OUTER',
  'VIEW',
  'END',
  'OVER',
  'WAITFOR',
  'ERRLVL',
  'PERCENT',
  'WHEN',
  'ESCAPE',
  'PIVOT',
  'WHERE',
  'EXCEPT',
  'PLAN',
  'WHILE',
  'EXEC',
  'PRECISION',
  'WITH',
  'EXECUTE',
  'PRIMARY',
  'WITHIN GROUP',
  'EXISTS',
  'PRINT',
  'WRITETEXT',
  'EXIT',
  'PROC'
];

export const PathKeys = {
  OrgList: '/org',
  Account: '/account',
  Projects: '/agent',
  Components: '/component_agent',
  Chatbots: '/chatbot_agent',
  Backends: '/backend_agent',
  OrgMembers: '/org/members',
  OrgSetting: '/org/setting',
  OrgSettingCopilot: '/org/copilot/copilot',
  OrgSettingBilling: '/org/setting/billing',
  ReadMe: '/readme',
  ServiceSchema: '/service_schema',
  FAKE_TYPES: '/type',
  KNOWLEDGE_SYSTEM_PROMPT: '/knowledge_system_prompt',
  KNOWLEDGES: '/knowledge',
  Intents: '/intent',
  DialogActs: '/dialog_act',
  Composites: '/composite',
  Entities: '/entity',
  Services: '/service',
  TestCase: '/test_case',
  Version: '/version',
  AgentSetting: '/agent/setting',
  AgentDebug: '/agent/debug',
  AgentDeploy: '/agent/deploy',
  DebugSetting: '/agent/debug_setting',
  OperateSetting: '/agent/operate_setting',
  Libraries: '/library',
  ProviderConnection: '/provider_connection',
  Integration: '/integration',
  Outbound: '/outbound'
};

export const PathKeyRegxMap = {
  [PathKeys.OrgList]: [/\/org/, /\/org\/add/],
  [PathKeys.Account]: /\/account/,
  [PathKeys.Projects]: /\/org\/[0-9a-zA-Z_.]+\/agent/,
  [PathKeys.Components]: /\/org\/[0-9a-zA-Z_.]+\/component_agent/,
  [PathKeys.Chatbots]: /\/org\/[0-9a-zA-Z_.]+\/chatbot_agent/,
  [PathKeys.Backends]: /\/org\/[0-9a-zA-Z_.]+\/backend_agent/,
  [PathKeys.OrgMembers]: /\/org\/[0-9a-zA-Z_.]+\/member/,
  [PathKeys.OrgSetting]: /\/org\/[0-9a-zA-Z_.]+/,
  [PathKeys.OrgSettingCopilot]: /\/org\/[0-9a-zA-Z_.]+\/copilot/,
  [PathKeys.OrgSettingBilling]: /\/org\/[0-9a-zA-Z_.]+\/billing/,
  [PathKeys.ReadMe]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/readme/,
  [PathKeys.ServiceSchema]: [
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/service_schema/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/service_schema\/slot\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/service_schema\/base\/\w{24,}/
  ],
  [PathKeys.FAKE_TYPES]: [/\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/type/,
    // [PathKeys.Intents]: [
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/intent/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/intent\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/intent\/\w{24,}\/slot\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/intent\/\w{24,}\/function\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/intent\/\w{24,}\/response\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/intent\/\w{24,}\/state_update\/\w{24,}/,
    // ],
    // [PathKeys.DialogActs]: [
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/dialog_act/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/dialog_act\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/dialog_act\/\w{24,}\/slot\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/dialog_act\/\w{24,}\/function\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/dialog_act\/\w{24,}\/response\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/dialog_act\/\w{24,}\/state_update\/\w{24,}/,

    // ],
    // [PathKeys.Composites]: [
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/frame/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/frame\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/frame\/\w{24,}\/slot\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/frame\/\w{24,}\/function\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/frame\/\w{24,}\/state_update\/\w{24,}/,
    // ],
    // [PathKeys.Entities]: [
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/entity/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/entity\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/entity\/\w{24,}\/function\/\w{24,}/,
  ],
  [PathKeys.KNOWLEDGE_SYSTEM_PROMPT]: /\/org\/[0-9a-zA-Z_.]+\/agent\/[0-9a-zA-Z_.]+\/struct\/knowledge_system_prompt/,
  [PathKeys.KNOWLEDGES]: [/\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/type/,
    /\/org\/[0-9a-zA-Z_.]+\/agent\/[0-9a-zA-Z_.]+\/struct\/knowledge/,
    /\/org\/[0-9a-zA-Z_.]+\/agent\/[0-9a-zA-Z_.]+\/struct\/knowledge\/\w{24,}/
  ],
  [PathKeys.Services]: [
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/service/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/service\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/service\/\w{24,}\/slot\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/service\/\w{24,}\/function\/\w{24,}/,
    /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/service\/\w{24,}\/base\/\w{24,}/
  ],
  [PathKeys.TestCase]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/test_case/,
  [PathKeys.Version]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/version/,
  [PathKeys.AgentSetting]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/setting/,
  [PathKeys.DebugSetting]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/debug_setting/,
  [PathKeys.OperateSetting]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/operate_setting/,
  [PathKeys.AgentDebug]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/debug/,
  [PathKeys.AgentDeploy]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/deploy/,
  [PathKeys.Libraries]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/library/,
  [PathKeys.ProviderConnection]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/provider_connection/,
  [PathKeys.Integration]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/integration/,
  [PathKeys.Outbound]: /\/org\/[0-9a-zA-Z_.]+\/(agent|service_agent)\/[0-9a-zA-Z_.]+\/(struct|en|zh)\/outbound/
};


export function underscoreToPascalCase(str: string): string {
  if (!str || typeof str !== 'string') {
    return str;
  }

  return str
    .split('_') // 将字符串按 "_" 分割成数组
    .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // 将每个单词的首字母大写
    .join(''); // 将转换后的单词连接成一个字符串
}

// export function newObjectID(): string {
//   return newObjectIDFromTimestamp(new Date());
// }

// const processUnique = new Uint8Array(window.crypto.getRandomValues(new Uint8Array(3)));
// const objectIDCounter = Math.floor(Math.random() * 0xFFFFFF);

// function atomicIncrement(counter: number): number {
//   return (counter + 1) % 0xFFFFFF;
// }

// export function newObjectIDFromTimestamp(timestamp: Date): string {
//   const b = new Uint8Array(12);
//   const timestampSecs = Math.floor(timestamp.getTime() / 1000);
//   b.set(new Uint8Array([
//     (timestampSecs >> 24) & 0xFF,
//     (timestampSecs >> 16) & 0xFF,
//     (timestampSecs >> 8) & 0xFF,
//     timestampSecs & 0xFF,
//   ]), 0);
//   b.set(new Uint8Array([
//     (processUnique[0] >> 8) & 0xFF,
//     processUnique[0] & 0xFF,
//     (processUnique[1] >> 8) & 0xFF,
//     processUnique[1] & 0xFF,
//     (processUnique[2] >> 8) & 0xFF,
//     processUnique[2] & 0xFF,
//   ]), 4);
//   const counter = atomicIncrement(objectIDCounter);
//   b.set(new Uint8Array([
//     (counter >> 16) & 0xFF,
//     (counter >> 8) & 0xFF,
//     counter & 0xFF,
//   ]), 9);
//   return hexEncode(b);
// }

// export function timestamp(id: string): Date {
//   const unixSecs = parseInt(id.slice(0, 8), 16);
//   return new Date(unixSecs * 1000);
// }

// export function hexEncode(b: Uint8Array): string {
//   return Array.from(b).map(x => x.toString(16).padStart(2, '0')).join('');
// }
